<template>
  <div>
    <v-app>
      <main>
        <router-view></router-view>

        <!-- Global loader spinner -->
        <div v-if="isLoading" id="loader-container" class="text-center">
          <v-progress-circular id="loader-v-progress" indeterminate color="#0F1547" :size="150" :width="10">
            <v-label
              >Chargement...
              <!-- <br />
              {{ currentNumberOfRequests }} -->
            </v-label>
          </v-progress-circular>
          <div id="loader-background" class="text-center"></div>
        </div>
      </main>

      <!-- Global snackbar for errors and messages -->
      <v-container>
        <v-snackbar
          v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
          :key="snackbar.text + Math.random()"
          v-model="snackbar.showing"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          :style="`bottom: ${index * 110 + 5}px`"
          :right="!snackbar.centered"
        >
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div>
                <h4>{{ snackbar.title }}</h4>
              </div>
              <div>{{ snackbar.text }}</div>
            </v-layout>
            <!-- <v-btn
            v-if="snackbar.timeout === 0"
            icon
            @click="snackbar.showing = false"
          > -->
            <v-btn icon @click="snackbar.showing = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-layout>
        </v-snackbar>
      </v-container>

      <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons" />
    </v-app>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import "@/directives/requiredProviders";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    auth: () => AuthService,

    // Vuex map state on snackbars
    ...mapState(["snackbars"]),
    // Vuex map state on isLoading
    ...mapState(["isLoading"]),
    ...mapState(["currentNumberOfRequests"]),
  },
};
</script>

<style lang="scss" scoped>
.progress {
  margin: 0px;
  padding: 0px;
  height: 5px;
}

a.router-link-active {
  font-weight: bold;
}

#loader-container {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 999;

  #loader-v-progress {
    margin: 50px;
    top: 30vh;
    z-index: 990;
  }

  #loader-background {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background-color: #efefef;
    z-index: 980;
    opacity: 0.6;
  }
}
</style>

<style lang="scss">
// force snackbar style to display enough information if required
.v-snack__wrapper {
  max-width: none !important;
  max-height: 110px !important;
  white-space: pre-wrap;
}

@import "@/styles/global.scss";
</style>
